<div class="row">
  <div class="col content_filter !tw-p-0">
    <ng-container *ngIf="isFromHeader else legacyFinder">
      <form class="showing_hotels_list">
        <div class="tw-w-full">
          <input 
            type="text" 
            [placeholder]="('commons.search' | translate )"
            [formControl]="filterControl"
            [matAutocomplete]="auto"
            autofocus
            #inputAuto
            class="tw-w-full tw-px-4 tw-py-2 tw-border-none tw-rounded-md focus:tw-outline-none"
          />
          
          <div class="result-state">
            <mh-spinner-classic *ngIf="waitingOptions"></mh-spinner-classic>
            <div *ngIf="noResultsFlag" class="not-results">{{('shared.filters.customers.empty_message' | translate)}}</div>
            <div *ngIf="minCharsFlag" class="not-results tw-whitespace-nowrap">{{('shared.filters.customers.min_chars' | translate)}}</div>
            <div *ngIf="errorFlag" class="not-results link">
              <a (click)="fillListCorporative()">{{ 'errors.default' | translate }}</a>
            </div>
          </div>

          <mat-autocomplete #auto="matAutocomplete" [panelWidth]="'430px'" (optionSelected)="updateCustomer($event.option.value)" >
            <mat-option [value]="'all'" *ngIf="showAllOption">
              <div class="tw-flex tw-items-center tw-min-w-0">
                <div class="tw-min-w-0 tw-w-full tw-overflow-x-auto tw-whitespace-nowrap">{{ 'commons.select_all' | translate}}</div>
              </div>
            </mat-option>

            <mat-optgroup *ngFor="let group of filteredGroups | async"
                       [label]="('countries.'+ (group.country_code || 'N.D.') | translate)"
                       >
                       <mat-option *ngFor="let hotel of group.customers" [value]="hotel" [attr.data-hotel-id]="hotel.id">
                         <div class="tw-flex tw-items-center tw-min-w-0">
                           <div class="tw-min-w-0 tw-w-full tw-overflow-x-auto tw-whitespace-nowrap">{{ hotel?.name }}<span> ({{hotel?.id}})</span></div>
                         </div>
                       </mat-option>
            </mat-optgroup>
          </mat-autocomplete>
        </div>
      </form>
    </ng-container>
  </div>
</div>

<ng-template #legacyFinder>
  <div ngbDropdown #myDrop="ngbDropdown" class="d-inline-block" *ngIf="show_toggle" [autoClose]="true">
    <button type="button" [class.button-toggled]="opened" class="btn btn-outline-primary btn-open" [id]="filterId" ngbDropdownToggle (click)="toggleSearch(myDrop)" NgbDropdownToggle></button>
    <div ngbDropdownMenu aria-labelledby="hotelsList">
      <form class="showing_hotels_list">
        <div class="tw-p-4 tw-min-w-[300px]">
          <input 
            type="text" 
            [placeholder]="('commons.search' | translate )"
            [formControl]="filterControl"
            [matAutocomplete]="auto"
            #inputAuto
            class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-rounded-md focus:tw-outline-none focus:tw-border-blue-400 tw-bg-white"
          />
          
          <div class="result-state tw-mt-2">
            <mh-spinner-classic *ngIf="waitingOptions"></mh-spinner-classic>
            <div *ngIf="noResultsFlag" class="not-results">{{('shared.filters.customers.empty_message' | translate)}}</div>
            <div *ngIf="minCharsFlag" class="not-results">{{('shared.filters.customers.min_chars' | translate)}}</div>
            <div *ngIf="errorFlag" class="not-results link">
              <a (click)="fillListCorporative()">{{ 'errors.default' | translate }}</a>
            </div>
          </div>

          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="updateCustomer($event.option.value)">
            <mat-option [value]="'all'" *ngIf="showAllOption">
              <div class="tw-flex tw-items-center tw-min-w-0">
                <div class="tw-min-w-0 tw-w-full tw-overflow-x-auto tw-whitespace-nowrap">{{ 'commons.select_all' | translate}}</div>
              </div>
            </mat-option>

            <mat-optgroup *ngFor="let group of filteredGroups | async"
                       [label]="('countries.'+ (group.country_code || 'N.D.') | translate)"
                       >
                       <mat-option *ngFor="let hotel of group.customers" [value]="hotel" [attr.data-hotel-id]="hotel.id">
                         <div class="tw-flex tw-items-center tw-min-w-0">
                           <div class="tw-min-w-0 tw-w-full tw-overflow-x-auto tw-whitespace-nowrap">{{ hotel?.name }}<span> ({{hotel?.id}})</span></div>
                         </div>
                       </mat-option>
            </mat-optgroup>
          </mat-autocomplete>
        </div>
      </form>
    </div>
  </div>
</ng-template>
